import React, { useMemo } from 'react'
import Layout from '@v4/components/common/Layout'
import { SectionManager } from './Default.utils'

const Default = () => {
	const sectionsMap = useMemo(() => {
		return SectionManager.getAllSections()
	}, [])

	return <Layout sectionsMap={sectionsMap} />
}

Default.SectionManager = SectionManager

export default Default
